import Reveal from '@/components/feature/Reveal';
import { hotTags } from '@/mocks/home';

const sizeClass = [
  'text-xs px-3 py-1.5',
  'text-sm px-4 py-2',
  'text-base px-5 py-2.5 font-semibold',
];

export default function TagSection() {
  return (
    <section id="tags" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-5xl px-4 text-center md:px-6">
        <Reveal>
          <span className="font-label text-xs tracking-[0.28em] text-primary-600">TAGS</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            大家在找什么
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-foreground-600">
            标签越醒目，说明最近被点开的次数越多。挑一个进去，往往比自己翻分类更快。
          </p>
        </Reveal>

        <Reveal delay={100} className="mt-8 md:mt-10">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {hotTags.map((tag) => (
              <a
                key={tag.name}
                href="#categories"
                className={`cursor-pointer whitespace-nowrap rounded-full border font-label transition-colors ${sizeClass[tag.level - 1]} ${
                  tag.level === 3
                    ? 'border-primary-300 bg-primary-100 text-primary-800 hover:bg-primary-200'
                    : tag.level === 2
                      ? 'border-secondary-200 bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
                      : 'border-background-300 bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {tag.name}
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}